import { APIv4 as API } from 'src/libs/axios';
import { alertError } from 'src/libs/toastify';
import { ShortShop } from 'src/pages/management/ShopsPage/ShortShopField/services';

const Messages = {
  FETCH_WAREHOUSES: 'Ошибка получения списка складов',
  FETCH_WAREHOUSE: 'Ошибка получения данных о складе',
  CREATE_WAREHOUSE: 'Ошибка создания склада',
  UPDATE_WAREHOUSE: 'Ошибка обновления склада',
  DELETE_WAREHOUSE: 'Ошибка удаления склада',
};

export type WarehouseListItem = {
  id: string;
  name: string;
  shop: ShortShop | null;
};

export type WarehouseDetail = {
  id: string;
  name: string;
  shopId: number | null;
};

export type WarehousePayload = {
  name: string;
  shopId: number | null;
};

export type WarehouseValues = {
  name: string;
  shop: ShortShop | null;
};

const adaptWarehouse = (values: WarehouseValues): WarehousePayload => ({
  name: values.name,
  shopId: values.shop?.id ?? null,
});

const mapWarehouseToValues = (data: WarehouseDetail): WarehouseValues => ({
  name: data.name,
  shop: data.shopId ? { id: data.shopId, name: '' } : null,
});

const BASE_URL = '/back-office/warehouses';

export const fetchAllWarehouses = (): Promise<WarehouseListItem[] | void> =>
  API.get<WarehouseListItem[]>(BASE_URL)
    .then(({ data }) => data)
    .catch((err) => alertError(err, Messages.FETCH_WAREHOUSES));

export const fetchWarehouse = ({
  id,
}: {
  id: string;
}): Promise<WarehouseValues | void> =>
  API.get<WarehouseDetail>(`${BASE_URL}/${id}`)
    .then(({ data }) => mapWarehouseToValues(data))
    .catch((err) => alertError(err, Messages.FETCH_WAREHOUSE));

export const addWarehouse = (data: WarehouseValues): Promise<string> =>
  API.post<string>(BASE_URL, adaptWarehouse(data)).then(({ data }) => data);

export const updateWarehouse = (params: {
  id: string;
  data: WarehouseValues;
}): Promise<boolean> =>
  API.put(`${BASE_URL}/${params.id}`, adaptWarehouse(params.data)).then(
    ({ data }) => Boolean(data)
  );

export const deleteWarehouse = ({ id }: { id: string }): Promise<boolean> =>
  API.delete(`${BASE_URL}/${id}`).then(({ data }) => Boolean(data));
